import AppSimpleAccordion from "./AppSimpleAccordion";

export default AppSimpleAccordion